import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TEASER_BOXES_ICON_CONVERTER_TOKEN, TeaserBoxesIconConverter } from './teaser-boxes-icon.component.converter'
import { TEASER_BOX_ICON_CONVERTER_TOKEN, TeaserBoxIconConverter } from './teaser-box-icon/teaser-box-icon.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        teaserBoxesIconFeature: {
          module: () => import('./teaser-boxes-icon.module').then((m) => m.TeaserBoxesIconModule),
          cmsComponents: ['teaserboxes_icon'],
        },
      }
    }),
    {
      provide: TEASER_BOXES_ICON_CONVERTER_TOKEN,
      useClass: TeaserBoxesIconConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaserboxes_icon: TEASER_BOXES_ICON_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TEASER_BOX_ICON_CONVERTER_TOKEN,
      useClass: TeaserBoxIconConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaserbox_icon: TEASER_BOX_ICON_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class TeaserBoxesIconFeatureModule {}
